import React, { forwardRef } from 'react'
import { cn } from '../utils/cn'

export interface HeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string
  description?: string
  actions?: React.ReactNode
  size?: 'sm' | 'md' | 'lg'
}

const Header = forwardRef<HTMLDivElement, HeaderProps>(
  ({ className, title, description, actions, size = 'md', ...props }, ref) => {
    const sizeClasses = {
      sm: {
        title: 'text-lg font-semibold',
        description: 'text-sm',
        spacing: 'space-y-1',
      },
      md: {
        title: 'text-xl font-semibold',
        description: 'text-sm',
        spacing: 'space-y-1',
      },
      lg: {
        title: 'text-2xl font-semibold',
        description: 'text-base',
        spacing: 'space-y-2',
      },
    }

    return (
      <div
        ref={ref}
        className={cn('flex items-start justify-between', className)}
        {...props}
      >
        <div className={cn(sizeClasses[size].spacing)}>
          <h1 className={cn('text-gray-900', sizeClasses[size].title)}>
            {title}
          </h1>
          {description && (
            <p className={cn('text-gray-600', sizeClasses[size].description)}>
              {description}
            </p>
          )}
        </div>
        
        {actions && (
          <div className="flex items-center gap-3 ml-4">
            {actions}
          </div>
        )}
      </div>
    )
  }
)

Header.displayName = 'Header'

export { Header } 